<template>
  <div class="RelaySSR2ASettings lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="RelaySSR2ASettings-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="RelaySSR2ASettings-main lxn-pos-rel">
      <div class="RelaySSR2ASettings-main-wrapper lxn-margin-auto lxn-border-round">
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.RelaySSR2ASettings_title1}}
          </template>
          <template v-slot:body>
            <div class="RelaySSR2ASettings-wrapper-outputState lxn-w100">
              <div class="RelaySSR2ASettings-wrapper-outputState-right lxn-h100" :class="$store.getters.language.floatClass">
                <div class="lxn-text" :class="[$store.getters.language.floatClass, $store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
                  {{$store.getters.language.texts.RelaySSR2ASettings_text1}}
                </div>
                <div class="lxn-text" :style="currentSwitchStateColor" :class="[$store.getters.language.floatClassReverse, $store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
                  {{currentSwitchStateText}}
                </div>
              </div>
              <div class="RelaySSR2ASettings-wrapper-outputState-left lxn-text lxn-h100" :class="$store.getters.language.floatClassReverse">
                <SingleSwitch @switchClicked="toggleOutput()" :state="currentSwitchState" :bgColorOn="titleBgColor" bgColorOff="#ACB8BF" bgColorPending="#CCCCCC" handleColorOn="#FFFFFF" handleColorOff="#FFFFFF" :disabled="isNodeOffline || isHubOffline" />
              </div>
            </div>
          </template>
        </TitleBox>
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.RelaySSR2ASettings_title2}}
          </template>
          <template v-slot:body>
            <div class="RelaySSR2ASettings-wrapper-fieldTitle lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.RelaySSR2ASettings_text2}}
            </div>
            <div class="lxn-w100">
              <DropDown v-model="currentOutputType" :dropDownContex="dropDown2Data" />
            </div>
            <div class="RelaySSR2ASettings-wrapper-fieldTitle lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.RelaySSR2ASettings_text3}}
            </div>
            <div class="lxn-w100">
              <customInput @focus="inputFieldState='active'" @blur="inputFieldState=''" :inputState="inputFieldState" v-model="currentOutputName" bgColor="#FFFFFF" :placeHolder="$store.getters.language.texts.AddNodeNameColor_placeHolder" inputType="text" />
            </div>
            <div v-if="isUserOwner" class="RelaySSR2ASettings-wrapper-fieldTitle lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.RelaySSR2ASettings_text4}}
            </div>
            <div v-if="isUserOwner" class="lxn-w100">
              <DropDown v-model="currentInitialState" :dropDownContex="dropDown1Data" :disabled="isNodeOffline || isHubOffline" />
            </div>
          </template>
        </TitleBox>
      </div>
      <div class="RelaySSR2ASettings-button lxn-margin-auto lxn-w100">
        <CustomButton @click="saveChanges" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
          {{$store.getters.language.texts.RelaySSR2ASettings_button}}
        </CustomButton>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import CustomButton from '@/components/CustomButton.vue'
import TitleBox from '@/components/TitleBox.vue'
import CustomInput from '@/components/CustomInput.vue'
import SingleSwitch from '@/components/SingleSwitch.vue'
import DropDown from '@/components/DropDown.vue'
import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'
import * as CONFIGS from '@/statics/configs.js'
import NODE2 from '@/statics/devices/Node2/header.js'

export default {
  name: 'RelaySSR2ASettings',
  components: {
    CustomCurve,
    TopNav,
    CustomButton,
    TitleBox,
    CustomInput,
    SingleSwitch,
    DropDown
  },
  data: function () {
    return {
      switchLocked: false,
      inputFieldState: '',
      node: this.$store.getters.getNodeByUUID(this.$route.params.nodeUUID),
      currentOutputName: '',
      currentOutputType: 0,
      currentInitialState: 0,
      currentSwitchState: 'off',
    }
  },
  watch: {
    switchState: function (newVal) {
      if(newVal != undefined){
        this.currentSwitchState = (newVal == 0) ? 'off' : 'on';
      }else{
        this.currentSwitchState = 'off';
      }
    },
    initialState: function (newVal) {
      if(newVal != undefined){
        this.currentInitialState = newVal;
      }else{
        this.currentInitialState = 0;
      }
    },
  },
  mounted: function () {
    this.currentOutputName = this.outputName;
    this.currentOutputType = this.output.settings.outputType;
    this.currentInitialState = this.initialState;
    this.currentSwitchState = this.switchState == 0 ? 'off' : 'on';

    var messagingHook = new Messaging(new Logger(false));
    messagingHook.init({
      psk: this.hub.psk,
      destinationUUID: this.hub.uuid,
      sourceUUID: this.$store.state.user.uuid
    });
    this.$store.dispatch('readNodeParameters', {messagingHook: messagingHook,hubUUID: this.hub.uuid,nodeUUID: this.node.uuid})
    .then( response => {
      this.$store.dispatch('processNodeParameters', {rawParameters: response.body.bodyContent.parameterList, nodeUUID: this.node.uuid});
    })
    .catch( response => {
      if(response.rejectCode == 2){
        this.$store.commit('setHubStatus', {
          hubIndex: response.hubIndex,
          connectionStatus: {
            local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
          },
        });
      }
    })
    .finally( () => {
      this.$store.commit('setHubStatus', {
        hubIndex: this.hub.index,
        stateUpdateEnabled: true,
      });
    });
  },
  destroyed: function () {
    this.$store.commit('cancelAllStateUpdates');
  },
  computed: {
    rssiStatus: function () {
      var targetParameterId = NODE2.LORA_RSSI.PARAMETER_ID;
      var rssiStatus = this.$store.getters.getParameterValue(this.node.index, targetParameterId);
      return rssiStatus;
    },
    hub: function () {
      return this.$store.getters.getHubByUUID(this.node.hubUUID);
    },
    isUserOwner: function () {
      return this.hub.isOwner;
    },
    output: function () {
      return this.node.outputs[this.$route.params.outputIndex];
    },
    outputName: function () {
      return this.output.name;
    },
    isNodeOffline: function () {
      if(this.node.connectionStatus == 1){
        return false;
      }else{
        return true;
      }
    },
    isHubOffline: function () {
      if(this.hub.connectionStatus.local == 2 || this.hub.connectionStatus.online == 2){
        return false;
      }else{
        return true;
      }
    },
    titleBgColor: function () {
      return this.$store.state.themeMainColors[this.node.color];
    },
    switchState: function () {
      var switchState = this.$store.getters.getParameterValue(this.node.index, this.output.parameterId);
      if(switchState == undefined){
        return 0;
      }else{
        return switchState;
      }
    },
    currentSwitchStateText: function () {
      if(this.currentSwitchState == 'on'){
        return this.$store.getters.language.texts.RelaySSR2ASettings_switchState_On;
      }else if(this.currentSwitchState == 'off'){
        return this.$store.getters.language.texts.RelaySSR2ASettings_switchState_Off;
      }else{
        return 'undefined'
      }
    },
    initialState: function () {
      var initialState = this.$store.getters.getParameterValue(this.node.index, this.output.initialStateParameterId);
      if(initialState == undefined){
        return 0;
      }else{
        if(initialState == 6){
          initialState = 2;
        }
        return initialState;
      }
    },
    currentSwitchStateColor: function () {
      if(this.currentSwitchState == 'on'){
        return 'color: #2FBAEE';
      }else if(this.currentSwitchState == 'off'){
        return 'color: #52626C';
      }else{
        return 'color: #FFFFFF';
      }
    },
    dropDown1Data: function () {
      if (this.node.deviceType == 11){
        return {
          name: "RelaySSR2ASettings-outputInitialState",
          title: this.$store.getters.language.texts.RelaySSR2ASettings_text4,
          selectedIndex: this.currentInitialState,
          data: [
            {
              name: this.$store.getters.language.texts.RelaySSR2ASettings_initState2,
              icon: 'lamp',
            },
            {
              name: this.$store.getters.language.texts.RelaySSR2ASettings_initState1,
              icon: 'lamp',
            },
            {
              name: this.$store.getters.language.texts.RelaySSR2ASettings_initState6,
              icon: 'lamp',
            },
          ]
        }
      }else{
        return {
          name: "RelaySSR2ASettings-outputInitialState",
          title: this.$store.getters.language.texts.RelaySSR2ASettings_text4,
          selectedIndex: this.currentInitialState,
          data: [
            {
              name: this.$store.getters.language.texts.RelaySSR2ASettings_initState2,
              icon: 'lamp',
            },
            {
              name: this.$store.getters.language.texts.RelaySSR2ASettings_initState1,
              icon: 'lamp',
            },
          ]
        }
      }
    },
    dropDown2Data: function () {
      return {
        name: "RelaySSR2ASettings-outputType",
        title: this.$store.getters.language.texts.RelaySSR2ASettings_title2,
        selectedIndex: this.currentOutputType,
        data: [
          {
            name: this.$store.getters.language.texts.RelaySSR2ASettings_outputType1,
            icon: 'lamp',
          },
          {
            name: this.$store.getters.language.texts.RelaySSR2ASettings_outputType2,
            icon: 'lamp',
          },
          {
            name: this.$store.getters.language.texts.RelaySSR2ASettings_outputType3,
            icon: 'lamp',
          },
          {
            name: this.$store.getters.language.texts.RelaySSR2ASettings_outputType4,
            icon: 'lamp',
          },
          {
            name: this.$store.getters.language.texts.RelaySSR2ASettings_outputType5,
            icon: 'lamp',
          },
        ]
      }
    },
  },
  methods: {
    goBack: function () {
      this.$router.go(-1);
    },
    toggleOutput: function () {
      if(!this.switchLocked){
        this.$store.commit('setHubStatus', {
          hubIndex: this.hub.index,
          stateUpdateEnabled: false,
        });
        this.switchLocked = true;
        if(this.currentSwitchState == 'on'){
          this.currentSwitchState = 'off';
          var valueOfChange = 0;
        }else{
          this.currentSwitchState = 'on';
          valueOfChange = 1;
        }
        var messagingHook = new Messaging(new Logger(false));
        messagingHook.init({
          psk: this.hub.psk,
          destinationUUID: this.hub.uuid,
          sourceUUID: this.$store.state.user.uuid
        });
        this.$store.dispatch('setNodesParameters', {
          messagingHook: messagingHook,
          hubUUID: this.hub.uuid,
          nodeUUID: this.node.uuid,
          bodyContent: {
            nodeActions: [
              {
                nodeUUID: this.node.uuid,
                actions: [
                  {
                    parameterId: this.output.parameterId,
                    valueOfChange: valueOfChange,
                    typeOfAction: CONFIGS.ACTION_TYPE_SET,
                    timeDelay: 0
                  }
                ]
              }
            ]
          }
        })
        .then( () => {
          this.switchLocked = false;
        })
        .catch( response => {
          this.switchLocked = false;
          if(response.rejectCode == 2){
            this.$store.commit('setHubStatus', {
              hubIndex: response.hubIndex,
              connectionStatus: {
                local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              },
            });
          }
        })
        .finally( () => {
          this.$store.commit('setHubStatus', {
            hubIndex: this.hub.index,
            stateUpdateEnabled: true,
          });
        });
      }
    },
    saveChanges: function () {
      this.inputFieldState = '';
      if(this.currentOutputName == ''){
        this.inputFieldState = 'error';
        alert(this.$store.getters.language.texts.RelaySSR2ASettings_alert);
      }else{
        this.$store.commit('setAppBusy', true);
        this.$store.commit('setNodeOutputName', {nodeIndex: this.node.index, outputIndex: this.$route.params.outputIndex, name: this.currentOutputName});
        this.$store.commit('setNodeOutputType', {nodeIndex: this.node.index, outputIndex: this.$route.params.outputIndex, type: this.currentOutputType});
        this.$store.commit('saveState');
        var currentInitialState = this.currentInitialState;
        if(!this.isNodeOffline && !this.isHubOffline && this.initialState != currentInitialState){
          if (this.node.deviceType == 11){
            if(currentInitialState == 2){
              currentInitialState = 6;
            }
          }
          var messagingHook = new Messaging(new Logger(false));
          messagingHook.init({
            psk: this.hub.psk,
            destinationUUID: this.hub.uuid,
            sourceUUID: this.$store.state.user.uuid
          });
          this.$store.dispatch('setNodesParameters', {
            messagingHook: messagingHook,
            hubUUID: this.hub.uuid,
            nodeUUID: this.node.uuid,
            bodyContent: {
              nodeActions: [
                {
                  nodeUUID: this.node.uuid,
                  actions: [
                    {
                      parameterId: this.output.initialStateParameterId,
                      valueOfChange: currentInitialState,
                      typeOfAction: CONFIGS.ACTION_TYPE_SET,
                      timeDelay: 0
                    }
                  ]
                }
              ]
            }
          })
          .then( () => {
            this.$router.push('/Home/Devices');
            this.$store.commit('setAppBusy', false);
          })
          .catch( response => {
            if(response.rejectCode == 1){
              this.$router.push('/SettingsNodeError');
            }else if(response.rejectCode == 2){
              this.$router.push('/SettingsHubError');
              this.$store.commit('setHubStatus', {
                hubIndex: response.hubIndex,
                connectionStatus: {
                  local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                  online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                },
              });
            }else{
              this.$router.push('/SettingsHubError');
            }
            this.$store.commit('setAppBusy', false);
          });
        }else{
          this.$router.push('/Home/Devices');
          this.$store.commit('setAppBusy', false);
        }
      }
    },
  }
}
</script>

<style>
  .RelaySSR2ASettings-topCurve-wrapper {
    height: 200px;
  }
  .RelaySSR2ASettings-main {
    z-index: 2;
  }
  .RelaySSR2ASettings-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding: 14px;
  }
  .RelaySSR2ASettings-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
  .RelaySSR2ASettings-wrapper-outputState {
    height: 50px;
    color: #52626C;
    line-height: 50px;
  }
  .RelaySSR2ASettings-wrapper-outputState-right {
    width: calc(100% - 84px);
  }
  .RelaySSR2ASettings-wrapper-outputState-left {
    width: 70px;
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .RelaySSR2ASettings-wrapper-fieldTitle:first-child {
    height: 25px;
    line-height: 25px;
    padding-top: 0;
  }
  .RelaySSR2ASettings-wrapper-fieldTitle {
    height: 35px;
    padding-top: 10px;
    line-height: 25px;
    color: #52626C;
  }
</style>
